<template>
  <div class="right_body_s">
      <Panel>
        <template v-slot:panel-top>
            <ToolBar class="infoActive_rumb">
                 <template slot="appendbuttons">
                       <span class="toolbar-item add_btn" @click="onCvtErpOrder"><i class="iconfont">&#xe678;</i>转ERP订单</span>
                 </template>                
            </ToolBar>
        </template>
        <template v-slot:panel-main>
            <FormGridPanel :tableColumns="columns" :queryForm="queryForm"></FormGridPanel>
        </template>
    </Panel>
  </div>
</template>
 
<script>
import FormGridPanel from "components/grid/FormGridPanel.vue";
import Panel from "components/container/BasePanel.vue";
import ToolBar from "components/bar/Toolbar.vue";

export default {
  components: {
    Panel,
    FormGridPanel,
    ToolBar
  },
  data() { 
    return {
      queryForm: {
          titleWidth: 100,
          titleAlign: "right",
          items: [
            {
              field: "goodsCode",
              title: "店铺名:",
              span: 6,
              itemRender: {
                name: "input",
                attrs: { placeholder: "请输入店铺名" }
              }
            },
            {
              field: "goodsDesc",
              title: "电商订单号:",
              span: 6,
              itemRender: {
                name: "input",
                attrs: { placeholder: "请输入电商订单号" }
              }
            },
            {
              field: "shopName",
              title: "买家名:",
              span: 6,
              itemRender: {
                name: "input",
                attrs: { placeholder: "请输入卖家名" }
              }
            },
            {
              span: 6,
              align: "right",
              collapseNode: true,
              itemRender: {
                name: "$buttons",
                children: [
                  {
                    props: {
                      type: "submit",
                      content: "查询",
                      status: "primary"
                    }
                  },
                  {
                    props: {
                      type: "reset",
                      content: "重置"
                    }
                  }
                ]
              }
            },
            {
              field: "factoryCode",
              title: "卖 家:",
              span: 6,
              folding: true,
              itemRender: {
                name: "input",
                attrs: { placeholder: "请输入卖 家" }
              }
            },
            {
              field: "materialCode",
              title: "送货地址:",
              span: 6,
              folding: true,
              itemRender: {
                name: "input",
                attrs: { placeholder: "请输入送货地址" }
              }
            }
          ],
          data: {}
      },
      columns: [
        // { type: "checkbox", width: 60, fixed: "left" },
        { type: "seq", width: 80, title: "序号", fixed: "left" },
        {
          field: "shopName",
          title: "店铺名",
          remoteSort: true,
          editRender: { name: "input" }
        },
        {
          field: "goodsCode",
          title: "电商订单号",
          remoteSort: true,
          editRender: { name: "input" }
        },
        // 单元格渲染，自动读取字典配置
        {
          field: "goodsDesc",
          title: "电商订单日期",
          cellRender: { name: "DICT", props: { code: "OPERATE_STATUS" } }
        },
        // 单元格编辑渲染，自动读取字典配置
        {
          field: "goodsSpeci",
          title: "来源平台",
          editRender: { name: "$select", options: { dict: "COLOR_STATUS" } }
        },
        // 单元格编辑渲染，自动请求异步配置
        {
          field: "calculateUnitDesc",
          title: "卖家名",
          remoteSort: true,
          editRender: {
            name: "$select",
            options: { url: "/api/conf/sex/list" }
          }
        },
        // 筛选渲染，自动请求异步配置
        {
          field: "materialCode",
          title: "卖家名",
          remoteSort: true,
          width: 200,
          editRender: { name: "input" }
        },
        {
          field: "materialDesc",
          title: "卖家联系电话",
          showOverflow: true,
          editRender: { name: "input" }
        },
        {
          field: "receptStatus",
          title: "订单总价",
          showOverflow: true,
          editRender: { name: "input" }
        },
        {
          field: "receptComments",
          title: "送货地址",
          showOverflow: true,
          editRender: { name: "input" }
        },
        {
          width: 80,
          title: "操作",
          fixed: "right",
          slots: { default: "button" }
        }
      ]
    };
  },
  created() {},
  methods: {
    /**
     * 转erp订单
     */
    onCvtErpOrder(){

    }
  }
};
</script>

<style lang="stylus" scoped></style>
